import { useMutation } from 'react-query';
import {
  createCustomerRecognitionAsync,
  createCustomerRecognitionAsyncJob,
  deleteCustomerRecognitionAsyncJob,
  getCustomerRecognitionByIdAsync,
  updateCustomerRecognitionAsync,
  updateCustomerRecognitionAsyncJob,
} from '../../index';

export const useCreateCustomerRecognitionAsync = () =>
  useMutation(createCustomerRecognitionAsync);

export const useCreateCustomerRecognitionAsyncJob = () =>
  useMutation(createCustomerRecognitionAsyncJob);

export const useUpdateCustomerRecognitionAsync = () =>
  useMutation(updateCustomerRecognitionAsync);

export const useUpdateCustomerRecognitionAsyncJob = () =>
  useMutation(updateCustomerRecognitionAsyncJob);

export const useDeleteCustomerRecognitionAsyncJob = () =>
  useMutation(deleteCustomerRecognitionAsyncJob);

export const useGetCustomerRecognitionByIdAsync = () =>
  useMutation(getCustomerRecognitionByIdAsync);
